import React from 'react';

import scss from './ReviewSlider.module.scss';
import { VwpReview } from '../types';

type SingleReviewProps = {
    review: VwpReview
}

const SingleReview = ({ review }: SingleReviewProps) => {
    return (
        <div className={scss.topContainer}>
            <div className={scss.reviewContainer}>
                <div className={scss.imageContainer}>
                    <div className={scss.imageWithQuote}>
                        <img className={scss.image} src={review.Thumbnail} />
                    </div>
                </div>
                <div className={scss.reviewContent}>
                    <div className={scss.description}>{review.Description}</div>
                    <div className={scss.name}>{review.ReviewerName}</div>
                </div>
            </div>
        </div>
    );
};

export default SingleReview;